import React from 'react';
import HomeSection3 from '../../HomeSection3';
import './Terms.css';

import {
    sectionFiveObj,
} from './Data';

import '../Footer/Footer.css';

const Terms2 = ({ lightBg }) => {
    return (
        <div>
            <HomeSection3 {...sectionFiveObj} />

            <div className={lightBg ? 'terms__home-section' : 'terms__home-section darkBg'}>
                  <div className="container">
                    <p className="terms">
                        <br/><br/>
                        <b>Privacy Policy</b>
                        <br/><br/>
                        Shenzu Spending (“we,” “our,” or “us”) is committed to protecting your privacy. 
                        This Privacy Policy explains how we collect, use, share, and safeguard your personal 
                        information when you use our services in compliance with applicable data protection laws.
                        <br/><br/>

                        <b>1. Information We Collect</b><br/>
                        <u>a. Personal Information</u><br/>
                        - Name, email address, phone number, and billing information.<br/>
                        - Identification information required for compliance purposes (KYC/AML).<br/><br/>

                        <u>b. Financial Information</u><br/>
                        - Payment details processed via Stripe (FCA Number: 900461).<br/>
                        - Transaction history stored securely on Stellar blockchain for cross-border payments.<br/><br/>

                        <u>c. Technical Information</u><br/>
                        - IP address, device type, browser type, and usage data for analytics and service optimization.<br/><br/>

                        <u>d. AI-related Data</u><br/>
                        - AI-powered financial analytics and personalized financial insights.<br/>
                        - Predictive analytics for smarter financial decisions.<br/>
                        <br/><br/>

                        <b>2. How We Use Your Information</b><br/>
                        - Provide and improve services<br/>
                        - Comply with legal and regulatory requirements (e.g., KYC/AML).<br/>
                        - Communicate with you about account activity, updates, and promotions.<br/>
                        - Analyze trends, usage, and optimize user experience.<br/>
                         <br/><br/>

                        <b>3. Sharing Your Information</b><br/>
                        - Payment Processors: Stripe <br/>
                        - Blockchain Services: Stellar network.<br/>
                        - AI/Tech Providers: Lamatic.ai & Abv.dev  <br/>
                        - Legal: When required by law or regulation.<br/>
                        - Service Providers: Vendors assisting us in service delivery.<br/><br/>

                        We do not sell your personal information to third parties for marketing purposes.<br/><br/>

                        <b>4. Data Security</b><br/>
                        We implement:<br/>
                        - Encrypted storage and transmission (SSL/TLS).<br/>
                        - Access controls and authentication protocols.<br/>
                        - Regular security audits and compliance checks.<br/><br/>

                        <b>5. Cookies and Tracking Technologies</b><br/>
                        We use cookies, web beacons, and similar technologies to improve performance, track engagement, and provide personalized services. 
                        You can manage your cookie preferences in your browser settings.<br/><br/>

                        <b>6. Your Rights</b><br/>
                        Depending on your jurisdiction, you may request to access, correct, delete, restrict, or object to processing of your data. 
                        You may also request data portability or withdraw consent.<br/><br/>
                        To exercise your rights, contact us at <a href="mailto:support@shenzuspending.com">support@shenzuspending.com</a>.<br/><br/>

                        <b>7. Third-Party Links</b><br/>
                        Our services may contain links to third-party websites. We are not responsible for their privacy practices.<br/><br/>

                        <b>8. Updates to This Policy</b><br/>
                        We may update this Privacy Policy periodically. Changes will be posted with an updated “Last Updated” date.<br/><br/>

                        <b>9. Contact Us</b><br/>
                        Email: <a href="mailto:support@shenzuspending.com">support@shenzuspending.com</a><br/>
                        Shenzu Spending Pvt. Ltd., CIN:U96090KA2023PTC181153<br/>
                        Shenzu Spending Ltd., Company Number: 15334747<br/><br/>

                        Last Updated: 25-09-2025
                        <br/><br/>
                    </p>
                </div>
            </div>
        </div>
    );
}

export default Terms2;
